import { createSelector } from 'reselect';

import { StateType } from '../../index';
import { activeTabIndexSelector } from '../../EditorReducer/EditorSelector';

import { INFO_SIMULATION_FILTERS_MAP } from './FiltersConfig';

export const filtersSelector = (state: StateType) => state.getIn(['simulation', 'filters']);
export const activeFiltersSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex])
);

export const filtersCodeSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex, 'code'])
);

export const filtersSuperCodeSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex, 'superCode'])
);

export const filtersResultsSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex, 'results'])
);

export const filtersLearnSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex, 'learn'])
);
export const filtersDataExplorerSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex, 'dataExplorer'])
);

export const filtersTutorialSelector = createSelector(
  filtersSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (filters, activeTabIndex) => filters.getIn([activeTabIndex, 'tutorial'])
);

export const activeInfoFilterSelector = createSelector(
  activeFiltersSelector,

  // @ts-ignore
  filters => {
    for (const [, filterName] of INFO_SIMULATION_FILTERS_MAP) {
      if (!!filters?.get(filterName)) {
        return filterName;
      }
    }
    return undefined;
  }
);
